/*
 *
 *  Login
 *  contains basic js for the contact page
 *  !! Created by Jurgen on 29/08/2017
 *
 */

$(document).ready(function () {
    // Initialize strTypeLogin (login | loginpopup)
    if (typeof strPage === 'undefined') {
        strPage = 'login';
    }

    // Check if login or register
    if (strPage == 'login') {
        // LOGIN
        // Initialize strTypeLogin (login | loginpopup)
        if (typeof strTypeLogin === 'undefined') {
            strTypeLogin = 'login';
        }

        // Login
        FormValidateLogin($('form#frmLogin'), strTypeLogin);

        // login popup
        // Close popup when you are already loggedin
        // if (blnClosePopup) {
        //     parent.$.fancybox.close();
        // }
    } else {
        // Register
        // Remove company fields
        $('form .company').hide();

        // Clicking on 'Particulier' => hide company fields
        $('form input[id="optVatTypeP"]').on('click', function () {
            $('form .company').slideUp();
            // Remove all errors
            $('form .company input#txtCompanyname').removeClass('required error');
            $('form .company input#txtCompanyname').find('label.error').remove();
        });

        // Clicking on 'Bedrijf' => show company fields
        $('form input[id="optVatTypeB"]').on('click', function () {
            $('form .company').slideDown();
            $('form .company input#txtCompanyname').addClass('required');
        });

        if (WebsiteSettingBlnUseState) {
            // Change the country
            $('form select[id="selCountry"]').on('change', function () {
                var strParams = 'strCountryCode=' + $(this).val();

                // Get states from the selected country
                $.post(strAjaxPath + 'cart/get-state.php', strParams, function (arrObjecten) {
                    var intNumber = Object.keys(arrObjecten).length;

                    if (intNumber > 0) {
                        // Show areas
                        $('#area-container').removeClass('d-none');
                        $('#selState').find('option').remove();

                        $.each(arrObjecten, function (i, val) {
                            $('#selState').append('<option value=\'' + val.areacode + '\'>' + val.areaname + '</option>');
                        });
                    } else {
                        // Hide areas
                        $('#area-container').addClass('d-none');
                        $('#selState').find('option').remove();
                    }
                }, 'json');
            });
        }

        // Open conditions in popup
        $('a.conditions').on('click', function () {
            $.fancybox.open({
                src: '.conditions-page',
                type: 'inline',
                beforeShow: function () {
                    $('div.conditions-page').removeClass('d-none');
                },
            });
            return false;
        });

        // Form validate
        var validator = FormValidateRegister($('form#frmRegister'));

        $('#btnRegister').on("click", function (event) {
            event.preventDefault();
            FormValidateRegister($('form#frmRegister'));
            if ($('form#frmRegister').valid()) {
                turnstile.render('.g-recaptcha', {
                    sitekey: WebsiteSettingStrRecaptchaSiteKey,
                    callback: function () {
                        $('form#frmRegister').submit();
                    },
                });
            }
        });

        // Clicking on a membership
        /*$('input[name="optMembership"]').click(function () {

            var blnValidationChanged = false;
            // Check if clicked on 'No member'
            if ($(this).val() == WebsiteSettingIntAddressGroupNoMember) {
                // No member choosen => check if field dateofbirth was required
                if ($('input#txtDateOfBirth').hasClass('required')) {
                    // For no members the dateofbirth field is not required => remove required attribute from this field and re-validate the form
                    $('input#txtDateOfBirth').removeClass('required');
                    $('input#txtDateOfBirth').removeClass('is-invalid');
                    $('input#txtDateOfBirth').closest('div').find('label.invalid-feedback').remove();
                    blnValidationChanged = true;
                }
            } else {
                // Member or VIP member choosen => check if field dateofbirth was not required
                if (!$('input#txtDateOfBirth').hasClass('required')) {
                    // For member/VIP member the dateofbirth field is required => make field required and re-validate the form
                    $('input#txtDateOfBirth').addClass('required');
                    blnValidationChanged = true;
                }

                // Check if member choosen (not VIP)
                // if ($(this).val() != WebsiteSettingIntAddressGroupVipMember) {
                //     if (!$('input#chkNewsletter').hasClass('required')) {
                //         $('input#chkNewsletter').addClass('required');
                //         blnValidationChanged = true;
                //     }
                // }
            }

            // Check if some filed became required/not required
            if (blnValidationChanged) {
                // Re-validate the form
                validator.resetForm();
                $('form#frmRegister').removeData('validator');
                validator = FormValidateRegister($('form#frmRegister'));
            }
        });*/
    }
});

// // Use login.js
// $.getScript(strPath + 'javascript/default/base/pages/login.js', function () {
//
// });